import { Divider } from '@huggg/react-components';
import classnames from 'classnames';
import { Huggg } from 'components';
import { PageTitle } from 'components/misc';
import dict from 'config/dictionary';
import { withHuggg, withRedirect } from 'hoc';
import { useAnalytics } from 'hooks';
import { Layout } from 'layouts';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getEmail, getNumber } from 'redux/modules/stash';
import styles from './superhuggg-screens.module.scss';

export const ScreensStashedSuperhuggg = (props) => {
  const { huggg, email, number, isSuperhugggEmailClaim } = props;
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.screenViewedSuperhugggStashed();
  }, [analytics, huggg]);

  const renderContent = () => {
    const title = isSuperhugggEmailClaim
      ? dict.stashCompleteRedesign.superhuggg.title.email
      : dict.stashCompleteRedesign.superhuggg.title.sms;
    const value = isSuperhugggEmailClaim ? email : number;
    const subtitle = dict.stashCompleteRedesign.superhuggg.subtitle;
    const copy = isSuperhugggEmailClaim
      ? dict.stashCompleteRedesign.superhuggg.copy.email
      : dict.stashCompleteRedesign.superhuggg.copy.sms;

    return (
      <div className={styles.content}>
        <Divider />
        <div>{title}</div>
        <div className={styles.valueContainer}>
          <div className={styles.value}>{value}</div>
        </div>
        <Divider />
        <div className={styles.subtitle}>{subtitle}</div>
        <div>{copy}</div>
      </div>
    );
  };

  return (
    <Layout showBackButton={false}>
      <PageTitle huggg={huggg} />

      <div
        data-test-id="screen-stashed"
        className={classnames('container', styles.container)}
      >
        <Huggg huggg={huggg} />

        {renderContent()}
      </div>
    </Layout>
  );
};
ScreensStashedSuperhuggg.propTypes = {
  huggg: PropTypes.object.isRequired,
  isSuperhugggEmailClaim: PropTypes.bool.isRequired,
};

const redirectHandler = (props) => {
  const { huggg, isFirstStashed } = props;
  const url = huggg.isSuperhuggg
    ? `/super/${huggg.shortcode}/stash`
    : `/${huggg.shortcode}/stash`;

  return [!isFirstStashed, url];
};

const mapStateToProps = (state) => ({
  email: getEmail(state),
  number: getNumber(state),
});

export default compose(
  withHuggg,
  connect(mapStateToProps),
  withRedirect(redirectHandler),
)(ScreensStashedSuperhuggg);
